// @module Tavanoteam.ItemPromotions.ItemPromotions
define('Tavanoteam.ItemPromotions.ItemPromotions.View'
,	[
	'tavanoteam_itempromotions_itempromotions.tpl'

	,	'Tavanoteam.ItemPromotions.ItemPromotions.Model'
	,	'Tavanoteam.ItemPromotions.ItemPromotions.Modal.View'
	
	,	'Backbone'
	,	'Utils'
	,	'jQuery'
	,	'underscore'
    ]
, function (
	tavanoteam_itempromotions_itempromotions_tpl

	,	ItemPromotionsModel
	,	ItemPromotionsModalView
	
	,	Backbone
	,	Utils
	,	jQuery
	,	_
)
{
    'use strict';

	// @class Tavanoteam.ItemPromotions.ItemPromotions.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_itempromotions_itempromotions_tpl

		,	contextDataRequest: ['item']

	,	initialize: function (options) {

			Backbone.View.prototype.initialize.apply(this, arguments);

			var self = this;

			//Item Promotions Model
			this.model = new ItemPromotionsModel();

			//Get Options
			this.container = options.container;
			this.pdp = options.container.getComponent('PDP');
			this.layout = this.container.getComponent('Layout');

			//Get PDP Info
			this.item = this.pdp.getItemInfo().item;
			this.itemID;

			var getMatrix = this.pdp.getSelectedMatrixChilds();
			var isOptionSelected = getMatrix.length == 1 ? true : false;
			
			//If Item has Selected Item Option
			if (isOptionSelected) {

				var selectedChildArr = [];

				_.each(getMatrix, function(matrix){

					var matrixObj = {};
					matrixObj.sku = matrix.itemid;
					matrixObj.itemID = matrix.internalid;
					selectedChildArr.push(matrixObj);
					
					//Get Item ID of Selected Matrix Child Item
					self.itemID = selectedChildArr[0].itemID;

				});
			}
			else {
				//Get Item ID of Standalone Item
				this.itemID = this.item.internalid;
			}

			//Get Promotions After PDP Loads
			this.pdp.on('afterShowContent', function () {
				self.getPromotions();
			});

			//Get Promotions After Option Selection
			this.pdp.on('afterOptionSelection', function(event) {

				var getMatrix = self.pdp.getSelectedMatrixChilds();

				var selectedChildArr = [];

				_.each(getMatrix, function(matrix){

					var matrixObj = {};
					matrixObj.sku = matrix.itemid;
					matrixObj.itemID = matrix.internalid;
					selectedChildArr.push(matrixObj);

				});

				//Get Item ID of Selected Matrix Child Item
				self.itemID = selectedChildArr[0].itemID;

				self.getPromotions();

			  });

		}

		//Fetch Promotions Associated to Item
	, 	getPromotions: function () {
			var self = this;
			var itemID = this.itemID;

			this.model.fetch({ data: { itemId: itemID } }).done(function (result) {
				self.promotions = result;
				self.render();
			});
		}

	,	events: {
			'click [data-action="show-promotions"]': 'showPromotions',
		}

		//Show Pop-up Modal for List of Promotions
	,	showPromotions: function showPromotions() {

			if (this.hasPromotions) {
				var view = new ItemPromotionsModalView({ container: this.container,  promotions: this.promotions});
				this.layout.showContent(view, { showInModal: true});
			}

		}

		//@method getContext @return Tavanoteam.ItemPromotions.ItemPromotions.View.Context
	,	getContext: function getContext()
		{
			var self = this;
			
			//Get Promotions
			this.promotions = this.promotions || [];

			//If Item has Promotions
			this.hasPromotions = this.promotions.length > 0 ? true : false;
			
			//Get Link Text From SC Configuration
			this.getLinkText = SC.CONFIGURATION.TTItemPromotions.linkText;

			//@class Tavanoteam.ItemPromotions.ItemPromotions.View.Context

			return {
				hasPromotions: this.hasPromotions,
				linkText: this.getLinkText ? this.getLinkText : "View Promotions"
			};
		}
	});
});
